<template>
  <div class="container">
    <div class="calendar" ref="calendar">
      <div class="calendar-days">
        <span>Dim.</span>
        <span>Mar.</span>
        <span>Jeu.</span>
        <span>Sam.</span>
      </div>
      <div class="single-practice-container" v-for="n in numberOfDays" :key="n">
        <span class="month" v-if="checkMonthToDisplay(dateByIndex(n))">{{
          getMonthByDate(dateByIndex(n))
        }}</span>
        <SinglePractice
          :date="formattedDateByIndex(n)"
          :done="checkDates(formattedDateByIndex(n))"
          :displayed="n >= numberOfDays - 365"
          :reducedOpacity="
            selectedDate != null && selectedDate != formattedDateByIndex(n)
          "
          :focus="selectedDate == formattedDateByIndex(n)"
          @click="handleClick(formattedDateByIndex(n))"
        ></SinglePractice>
        <SinglePracticeTooltip
          class="tooltip"
          v-if="n >= numberOfDays - 365"
          :date="dateByIndex(n)"
        ></SinglePracticeTooltip>
      </div>
    </div>
    <div class="details">
      <SessionDetails :date="selectedDate" :note="sessionData"></SessionDetails>
    </div>
  </div>
</template>

<script>
import SinglePractice from "@/components/SinglePractice.vue";
import SinglePracticeTooltip from "@/components/SinglePracticeTooltip.vue";
import SessionDetails from "@/components/SessionDetails.vue";
import format from "date-fns/format";
import subDays from "date-fns/subDays";
import fr from "date-fns/locale/fr";
import isSunday from "date-fns/isSunday";
import getDate from "date-fns/getDate";

export default {
  components: {
    SinglePractice,
    SinglePracticeTooltip,
    SessionDetails
  },
  data() {
    return {
      selectedDate: null,
      sessionDetails: false
    };
  },
  props: {
    sessions: {
      type: Object,
      required: true
    }
  },
  methods: {
    dateByIndex(index) {
      const currentDate = new Date();
      const interval = this.numberOfDays - index;

      return subDays(currentDate, interval);
    },
    formattedDateByIndex(index) {
      const date = format(new Date(this.dateByIndex(index)), "yyyy-MM-dd");
      return date;
    },
    checkDates(date) {
      const sessionsKeys = Object.keys(this.sessions);
      return sessionsKeys.includes(date);
    },
    getMonthByDate(date) {
      return format(date, "MMM", { locale: fr });
    },
    checkMonthToDisplay(date) {
      if (isSunday(date) && getDate(date) <= 7) {
        return true;
      } else return false;
    },
    handleClick(date) {
      this.selectedDate = date;
    },
    scrollRight() {
      this.$refs.calendar.scrollTo({
        left: "10000",
        behavior: "auto"
      });
    }
  },
  computed: {
    numberOfDays() {
      return 365 + new Date().getUTCDay();
    },
    sessionData() {
      if (this.selectedDate && this.checkDates(this.selectedDate) == true) {
        return this.sessions[this.selectedDate].note;
      }

      if (this.selectedDate && this.checkDates(this.selectedDate) == false) {
        return "";
      }
      return null;
    }
  },
  mounted() {
    this.scrollRight();
  }
};
</script>

<style lang="scss" scoped>
@import "../style/variables";

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.calendar {
  height: $calendarHeight + 40px;
  padding-top: 40px;
  width: calc(100% - 60px);
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-content: flex-start;
  overflow: scroll;
}
.calendar-days {
  margin-right: 5px;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  line-height: 14px;
  height: 100px;
  width: 50px;
  text-align: end;
}
.calendar-days span {
  margin-bottom: 14px;
}

.single-practice-container {
  position: relative;
  margin: $squareMargin;
}
.month {
  font-size: 10px;
  position: absolute;
  left: 0;
  top: -14px;
}
.tooltip {
  display: none;
}
.single-practice-container:hover .tooltip {
  display: block;
  z-index: 20;
  top: -45px;
}
</style>